import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/relojTheme3.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class RelojCircle extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Circle = gltf.scene.getObjectByName("Circle", true);
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Reloj");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	onClearAnimation() {
		if (this.animation) {
			this.Circle.material.emissiveIntensity = 0
			this.animation.kill();
			this.animation = null
		}
	}

	onAnimateEmissive() {
		this.onClearAnimation()

		this.animation = gsap.to(this.Circle.material, {
			emissiveIntensity: 2,
			yoyo: true,
			repeat: -1,
			duration: 0.9,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
